import React, { Component } from 'react';
import { Button, Divider, Form, GridColumn, Header, Input, Segment, Grid, Checkbox } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import Link from 'react-router-dom/Link';
import Redirect from 'react-router-dom/Redirect';

const object = {};
const fetchGradingMethods = () => axios.get('/grading-methods');
const fetchGradedActivityStaffType = () => axios.get('/committee-member-types');
const fetchCourseImplementations = (obj) => axios.post('/students/course-implementations-for-current-academic-year', { ...obj });
const fetchStaff = () => axios.post('/employees/by-key/professor', { ...object });
const fetchExamTerms = () => axios.post('/exams/terms/', { ...object });
const fetchStudentGrade = () => axios.get(`/student-exams/grades-for-cancellation/${JSON.parse(localStorage.getItem('student')).id}`);
class CancelGradeAndNewCommitteeExam extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            id: '',
            name: '',
            gradingMethods: [],
            examTerms: [],
            courseStaff: [],
            staffTypes: [],
            studentGrade: [],

            gradingMethod: 2,
            examTerm: '',
            staffArray: [],
            date: null,
            classroom: '',
            comment: '',
            courseImplementations: [],
            courseImplementation: '',
            head: '',
            members: [],
            reserveMember: '',

            gradingMethodErr: false,
            examTermErr: false,
            staffArrayErr: false,
            dateErr: false,
            added: null,
            courseImplementationErr: false,
            headErr: false,
            membersErr: false,
            reserveMemberErr: false,

            startDate: null,
            endDate: null,

            grades: {},
            gradesArray: [],
            documentNumber: null,
            grade: null,

            createdExam: false,
            loading: true,
            inputDocNum: false,

            cancelChecked: true,
            creatingExam: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addExam = this.addExam.bind(this);
        this.fetchAll = this.fetchAll.bind(this);
        this.cancelGrade = this.cancelGrade.bind(this);
        this.handleCancelCheckedChange = this.handleCancelCheckedChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.fetchAll(this.props.id);
    }

    fetchAll(id) {
        let obj = { id: JSON.parse(localStorage.getItem('student')).id };
        axios.all([fetchGradingMethods(), fetchStaff(), fetchExamTerms(), fetchCourseImplementations(obj), fetchGradedActivityStaffType(), fetchStudentGrade()])
            .then(axios.spread((gradingMethodRes, staffRes, termsRes, courseRes, staffTypesRes, studentGradeRes) => {
                const gradingMethods = gradingMethodRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));
                const courseStaff = staffRes.data.map(el => ({
                    ...el, text: el.lastName + ' ' + el.firstName, value: el.id, key: el.id
                }));

                const courseImplementations = courseRes.data.map(el => ({
                    text: el.courseImplementation.courseBasic.name, value: { courseImplementationId: el.courseImplementation.id, studentCourseImplementationId: el.id }, key: el.id
                }));

                const examTerms = termsRes.data.map(el => ({
                    ...el,
                    text: el.name + ' (' + moment(el.startDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.') + ')',
                    value: el.id + 1,
                    key: el.id + 1
                }));

                const studentGrade = studentGradeRes.data.map(el => ({
                    ...el,
                    text: el.courseBasicName + ' | ' + el.markDisplayName,
                    // text: 'test',
                    value: {
                        markId: el.studentMarkId, optLock: el.optLock, studentCourseImplementationId: el.studentCourseImplementationId, courseImplementationId: el.courseImplementationId
                    },
                    key: el.studentMarkId
                }));
                this.setState({
                    courseImplementations,
                    gradingMethods,
                    courseStaff,
                    studentGrade,
                    examTerms: examTerms.filter(el => el.endDate >= moment()),
                    staffTypes: staffTypesRes.data,
                    loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data...');
            });
    }


    addExam(examTerm, gradingMethodId, date, classroom, comment, courseImplementationId, grade, documentNumber) {
        const {
            head, members, reserveMember, staffTypes
        } = this.state;

        this.setState({ creatingExam: true });

        if (!examTerm || !gradingMethodId || !date || members.length !== 2 || !courseImplementationId || !head || (this.state.cancelChecked && (!grade || !documentNumber))) {
            if (members.length !== 2) {
                toast('Komisija treba imati predsjednika i dva člana!');
            } else { toast('Niste unijeli sva obavezna polja!'); }
            if (!examTerm) { this.setState({ examTermErr: true }); } else { this.setState({ examTermErr: false }); }
            if (!gradingMethodId) { this.setState({ gradingMethodIdErr: true }); } else { this.setState({ gradingMethodIdErr: false }); }
            if (!date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!courseImplementationId) { this.setState({ courseImplementationIdErr: true }); } else { this.setState({ courseImplementationIdErr: false }); }
            if (!head) { this.setState({ headErr: true }); } else { this.setState({ headErr: false }); }
            if (this.state.cancelChecked && (!documentNumber)) { this.setState({ documentNumberErr: true }); } else { this.setState({ documentNumberErr: false }); }
            if (this.state.cancelChecked && (!grade)) { this.setState({ gradeErr: true }); } else { this.setState({ gradeErr: false }); }
            if (members.length !== 2) { this.setState({ membersErr: true }); } else { this.setState({ membersErr: false }); }
        } else {
            if (this.state.cancelChecked) this.cancelGrade(this.state.grade.markId, this.state.grade.optLock);
            const { gradingMethods } = this.state;

            let examDate = moment(date).format();

            const gradedActivityRegistrationDate = { id: examTerm - 1 };

            let committeeGradedActivityStaff = members.map(el => ({ employeeId: el, committeeMemberTypeId: staffTypes.find(e => e._key === 'member').id }));

            committeeGradedActivityStaff = [...committeeGradedActivityStaff,
                {
                    employeeId: head,
                    committeeMemberTypeId: staffTypes.find(e => e._key === 'head').id
                }
            ];

            if (reserveMember) {
                committeeGradedActivityStaff = [...committeeGradedActivityStaff,
                    {
                        employeeId: reserveMember,
                        committeeMemberTypeId: staffTypes.find(e => e._key === 'reserve member').id
                    }
                ];
            }

            let gradingMethodKey = gradingMethods.find(el => el.id === gradingMethodId)._key;

            let docExam = {
                gradedActivityRegistrationDate,
                courseImplementationId: this.state.courseImplementation.courseImplementationId,
                gradingMethodKey,
                examDate,
                committeeGradedActivityStaff,
                classroom
            };

            if (comment) { docExam = { ...docExam, comment }; }

            axios.post('exams/true', { ...docExam })
                .then(res => {
                    let obj = {
                        id: this.state.grade ? this.state.grade.markId : null
                    };
                    let sciId = this.state.grade ? grade.studentCourseImplementationId : courseImplementationId.studentCourseImplementationId;
                    axios.post(`student-exams/committee/register/${res.data.gradedActivityId}/${sciId}`, { ...obj })
                        .then(res => {
                            this.setState({ added: true, createdExam: true, creatingExam: false });
                            toast('Komisijski ispit je uspješno kreiran.');
                        }).catch((e) => {
                            if (e.message === 'Network Error') {
                                this.setState({ added: true, createdExam: true, creatingExam: false  });
                                toast('Komisijski ispit je uspješno kreiran.');
                            } else {
                                toast('Došlo je do greške! Komisijski ispit nije kreiran.');
                                this.setState({ creatingExam: false });
                            }
                            // toast('Došlo je do greške! Komisijski ispit nije kreiran.');
                        });
                })
                .catch(err => {
                    toast('Došlo je do greške! Komisijski ispit nije kreiran.');
                });
        }
    }

    cancelGrade(id, optLock) {
        if (!this.state.documentNumber) {
            toast('Morate unijeti broj odluke!');
            this.setState({ docNumErr: true });
            return;
        }

        let obj = {
            id,
            optLock,
            documentNumber: this.state.documentNumber,

        };
        axios.put('/student-exams/cancel-mark/', { ...obj })
            .then(res => {
                toast('Ocjena je poništena.');
            })
            .catch(err => {
                toast('Došlo je do greške! Ocjena nije poništena.');
            });
    }

    handleCancelCheckedChange() {
        this.setState({
            grade: null,
            documentNumber: null,
            courseImplementation: null,
            cancelChecked: !this.state.cancelChecked
        });
    }

    handleChange(name, date) {
        if (moment(date).format('D.M.YYYY.') !== moment(this.state.startDate).format('D.M.YYYY.') && moment(date).format('D.M.YYYY.') !== moment(this.state.endDate).format('D.M.YYYY.')) {
            if (date < this.state.startDate || date > this.state.endDate) {
                toast('Datum ispita mora biti unutar vremenskog intervala odabranog ispitnog roka!');
                return;
            }
        }

        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        if (this.state.members.length > 1 && name === 'members' && value.length >= 3) {
            this.setState({ membersErr: true });
            toast('Maksimalan broj članova komisije je dva!');
            return;
        }
        this.setState({ membersErr: false });


        if (name === 'grade') { this.setState({ courseImplementation: { courseImplementationId: value.courseImplementationId } }); }

        this.setState({
            [name]: value
        });

        if (name === 'examTerm') {
            this.setState({
                endDate: this.state.examTerms.find(el => el.id === value - 1).endDate,
                startDate: this.state.examTerms.find(el => el.id === value - 1).startDate
            });
        }
    }

    render() {
        if (this.state.createdExam === true) {
            // eslint-disable-next-line react/jsx-no-undef
            return <Redirect push to={{ pathname: '/komisijski-ispiti' }} />;
        }
        const student = JSON.parse(localStorage.getItem('student'));
        const { grades, gradesArray, average } = this.state;
        return (
            <div>

                <h1>Kreiranje komisijskog ispita</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header
                            as="h3"
                            content={student.firstName + ' ' + student.lastName + ' - ' + student.index}
                            subheader="Student/ica / index"
                        />
                    </Segment>
                    {!student.locked && student.dateOfAbandonment === null && student.studyProgramStudentSwitchedToId === null ?
                        <Segment clearing>
                            <Form noValidate>
                                <Grid columns={2}>
                                    <Grid.Column>
                                        <Divider horizontal>
                                            <Header as="h2">
                                                <Checkbox
                                                    onChange={this.handleCancelCheckedChange}
                                                    checked={this.state.cancelChecked}
                                                    label={{ children: <Header as="h4">Poništavanje ocjene</Header> }}
                                                />
                                            </Header>
                                        </Divider>
                                        <Segment secondary>
                                            <Form.Group widths="equal">
                                                <Form.Field required={this.state.cancelChecked} error={this.state.gradeErr}>
                                                    <label>Ocjena</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        disabled={!this.state.cancelChecked}
                                                        placeholder="Odaberite ocjenu"
                                                        defaultValue={null}
                                                        value={this.state.grade}
                                                        onChange={this.handleInputChange}
                                                        name="grade"
                                                        options={this.state.studentGrade}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>
                                                <Form.Field
                                                    required={this.state.cancelChecked}
                                                    error={this.state.documentNumberErr}
                                                    label="Broj odluke"
                                                    control={Input}
                                                    disabled={!this.state.cancelChecked}
                                                    name="documentNumber"
                                                    value={this.state.documentNumber}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite broj"
                                                />
                                            </Form.Group>
                                        </Segment>
                                        <Divider horizontal><Header as="h4">Komisija</Header></Divider>
                                        <Segment secondary>
                                            <Form.Group widths="equal">
                                                <Form.Field required error={this.state.headErr}>
                                                    <label>Predsjednik</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        placeholder="Odaberite predsjednika"
                                                        value={this.state.head}
                                                        onChange={this.handleInputChange}
                                                        name="head"
                                                        options={this.state.courseStaff.filter(el => el.archived !== true)}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>
                                                <Form.Field disabled={!this.state.members.length}>
                                                    <label>Rezervni član</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        placeholder="Odaberite rezervnog člana"
                                                        value={this.state.reserveMember}
                                                        onChange={this.handleInputChange}
                                                        name="reserveMember"
                                                        options={this.state.courseStaff.filter(el => el.archived !== true && el.value !== this.state.head && el.value !== this.state.members[0] && el.value !== this.state.members[1])}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group widths="equal">
                                                <Form.Field required error={this.state.membersErr} disabled={!this.state.head}>
                                                    <label>Članovi</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        multiple
                                                        selection
                                                        placeholder="Odaberite članove"
                                                        value={this.state.members}
                                                        onChange={this.handleInputChange}
                                                        name="members"
                                                        options={this.state.courseStaff.filter(el => el.archived !== true && el.value !== this.state.head)}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>

                                            </Form.Group>
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Divider horizontal><Header as="h4">Podaci o ispitu</Header></Divider>


                                        <Segment secondary>
                                            <Form.Group widths="equal" >
                                                <Form.Field required error={this.state.examTermErr}>
                                                    <label>Ispitni rok</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        placeholder="Odaberite ispitni rok"
                                                        value={this.state.examTerm}
                                                        onChange={this.handleInputChange}
                                                        name="examTerm"
                                                        options={this.state.examTerms}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>


                                            </Form.Group>
                                            <Form.Group widths="equal" >

                                                <Form.Field required error={this.state.courseImplementationIdErr}>
                                                    <label>Predmet</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        placeholder="Odaberite predmet"
                                                        disabled={this.state.cancelChecked}
                                                        value={this.state.courseImplementation}
                                                        onChange={this.handleInputChange}
                                                        name="courseImplementation"
                                                        options={this.state.courseImplementations}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>


                                            </Form.Group>
                                            <Form.Group widths="equal">
                                                <Form.Field required error={this.state.dateErr} disabled={!this.state.examTerm}>
                                                    <label>Datum i vrijeme ispita</label>
                                                    <DateTimePicker
                                                        defaultValue={new Date()}
                                                        format="D. M. YYYY. - HH:mm"
                                                        timeFormat="HH:mm"
                                                        onChange={this.handleChange.bind(null, 'date')}
                                                        value={this.state.date}
                                                        placeholder="Unesite datum u formatu D. M. GGGG."
                                                    />
                                                </Form.Field>
                                                <Form.Field required error={this.state.gradingMethodErr}>
                                                    <label>Način ocjenjivanja</label>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        placeholder="Odaberite način ocjenjivanja"
                                                        value={this.state.gradingMethod}
                                                        onChange={this.handleInputChange}
                                                        name="gradingMethod"
                                                        options={this.state.gradingMethods}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group widths="equal">

                                                <Form.Field
                                                    label="Prostorija"
                                                    control={Input}
                                                    name="classroom"
                                                    value={this.state.classroom}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite prostoriju"
                                                />
                                                <Form.Field
                                                    label="Napomena"
                                                    control={Input}
                                                    name="comment"
                                                    value={this.state.comment}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite napomenu"
                                                />
                                            </Form.Group>
                                            <br />
                                        </Segment>
                                    </Grid.Column>
                                </Grid>

                                <br />

                                <Button
                                    basic="true"
                                    color="blue"
                                    floated="right"
                                    onClick={() => { this.setState({ added: null }); window.history.go(-1); }}
                                >
                                    Odustani
                                </Button>
                                {/* eslint-disable-next-line react/jsx-no-undef */}

                                <Button
                                    floated="right"
                                    color="blue"
                                    loading={this.state.creatingExam}
                                    disabled={this.state.creatingExam}
                                    onClick={
                                        () => {
                                            this.addExam(
                                                this.state.examTerm,
                                                this.state.gradingMethod,
                                                this.state.date,
                                                this.state.classroom,
                                                this.state.comment,
                                                this.state.courseImplementation,
                                                this.state.grade,
                                                this.state.documentNumber
                                            );
                                        }
                                    }
                                >
                                    Potvrdi
                                </Button>

                            </Form>
                        </Segment> : <Segment><p>Studentu/ici se ne može poništavati ocjena.</p></Segment>}
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default CancelGradeAndNewCommitteeExam;



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/CancelGradeAndNewCommitteeExam.js